import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDraftDialogPlay } from "store/bailiff/draft/dialog/draft_dialog.action";
import {
  draftDialogAdvanceSave,
  draftDialogEditCardSelector,
  draftDialogEditorEditSelector,
  draftDialogOpenAdvance,
  draftDialogPlaySelector,
  draftDialogSpeakerName,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
export const TriggerSpace = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const open = useSelector(draftDialogOpenAdvance);
  const play = useSelector(draftDialogPlaySelector);
  const editData = useSelector(draftDialogEditorEditSelector);
  const editName = useSelector(draftDialogSpeakerName);
  const editSave = useSelector(draftDialogAdvanceSave);
  const editCard = useSelector(draftDialogEditCardSelector);
  const edit = editData || editName || editSave || editCard;
  // -------------------------- FUNCTIONS --------------------------
  const togglePLay = useCallback(() => {
    dispatch(setDraftDialogPlay(!play));
  }, [dispatch, play]);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Kiểm tra nếu phím nhấn là Space (mã là "Space" hoặc code 32)
      if (event.code === "Space") {
        // Ngăn chặn hành vi cuộn trang mặc định của phím Space
        event.preventDefault();
        togglePLay();
      }
    };

    if (open && !edit) {
      // Đăng ký sự kiện khi component mount
      window.addEventListener("keydown", handleKeyDown);
    }

    // Hủy đăng ký khi component unmount để tránh rò rỉ bộ nhớ
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, edit, togglePLay]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerSpace;
